//@flow
import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import './styles.scss'

const isMobile = browserCheck.isMobile

export class CallBox extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
  }

  render() {
    return <div className='call-box'>
            <div className='top'>
              <div className='icon'>
                <img src={require('./loop.gif')} alt="gif" />
              </div>
              <div className='right'>
                <h4>Wir möchten ihre Kreationen sehen</h4>
                <div className="call">
                  Haben Sie auch schon mithilfe einer KI Bilder erzeugt?
                  Schicken Sie uns Ihre besten und amüsantesten Bildkreationen mit der zugehörigen Textanweisung an <a href='mailto:interaktiv@tamedia.ch'>interaktiv@tamedia.ch</a>
                </div>
              </div>
            </div>
          </div>
  }
}



             